import { FC, lazy, Suspense } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import { App } from '../App'

const WelcomeAccessPage = lazy(() => import('../modules/welcome/WelcomeAccessPage'))
const IosAppRedirect = lazy(() =>
  import('../modules/welcome/AppStoreRedirects').then((m) => ({ default: m.IosAppRedirect }))
)
const AndroidAppRedirect = lazy(() =>
  import('../modules/welcome/AppStoreRedirects').then((m) => ({ default: m.AndroidAppRedirect }))
)

const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const { currentUser } = useAuth();  
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route
            path='i'
            element={
              <Suspense fallback={<div />}>
                <IosAppRedirect />
              </Suspense>
            }
          />
          <Route
            path='a'
            element={
              <Suspense fallback={<div />}>
                <AndroidAppRedirect />
              </Suspense>
            }
          />
          <Route
            path='w/:token'
            element={
              <Suspense fallback={<div />}>
                <WelcomeAccessPage />
              </Suspense>
            }
          />
          <Route
            path='welcome/:token'
            element={
              <Suspense fallback={<div />}>
                <WelcomeAccessPage />
              </Suspense>
            }
          />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
            </>
          ) : ( 
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
           )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
